// extracted by mini-css-extract-plugin
module.exports = {"broadcastFixtureScreenWrapper":"style_broadcastFixtureScreenWrapper__3qlUR","broadcastFixtureScreen":"style_broadcastFixtureScreen__1XfIv","divider":"style_divider__vqP2g"};